var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',_vm._g({staticClass:"more"},_vm.$listeners),[_c('span',{staticStyle:{"margin-bottom":"4px"}},[_vm._v("...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }